const LOGIN = 'auth/login';
const LOGOUT = 'auth/logout';
const REFRESH = 'auth/refresh';
const REGISTER = 'auth/register';
const FORGOT_PASSWORD = 'auth/password-forgot';
const RESET_PASSWORD = 'auth/password-reset';
const LANGUGAGE_CHANGE = 'auth/language-change';
const CATEGORIES = 'occasions';
const HOME_PAGE = 'pages/home';

const PROMO = (slug: string): string => {
  return `creators/${slug}/orders/calculate`;
};
const MESSAGE = (slug: string): string => {
  return `creators/${slug}/orders`;
};
const CELEBRITY_INFO = (slug: string): string => {
  return `pages/profile/${slug}`;
};
const SHOUTOUT = (slug: string, orderId: string): string => {
  return `creators/${slug}/orders/${orderId}`;
};
const NOTIFY_ME = (slug: string): string => {
  return `creators/${slug}/notify-me`;
};
const EMAIL_OPT_IN = `newsletter/opt-in`;
const FACEBOOK_LOGIN = 'auth/facebook/login';

export default {
  LOGIN,
  LOGOUT,
  REFRESH,
  REGISTER,
  PROMO,
  FORGOT_PASSWORD,
  RESET_PASSWORD,
  CATEGORIES,
  MESSAGE,
  NOTIFY_ME,
  HOME_PAGE,
  CELEBRITY_INFO,
  SHOUTOUT,
  EMAIL_OPT_IN,
  LANGUGAGE_CHANGE,
  FACEBOOK_LOGIN,
};
